import { Component, inject, Inject } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';

@Component({
  selector: 'app-popup',
  templateUrl: './popup.component.html',
  styleUrls: ['./popup.component.scss']
})
export class PopupComponent {

  private _bottomSheetRef =
    inject<MatBottomSheetRef<PopupComponent>>(MatBottomSheetRef);

  constructor(@Inject(MAT_BOTTOM_SHEET_DATA) public data: IPopup) { }

  buttonClick(){
    this._bottomSheetRef.dismiss({ action: this.data.buttonAction });
  }

  linkClick(){
    this._bottomSheetRef.dismiss({ action: this.data.linkAction });
  }

  dismiss(){
    this._bottomSheetRef.dismiss();
  }

}

export interface IPopup{
  icon?: string;
  title?: string;
  text: string;
  asterisks?: string;
  buttonName: string;
  buttonAction: string | number;
  linkName?: string;
  linkAction?: string | number;
}
